import { render, staticRenderFns } from "./QuillRichTextEditor.vue?vue&type=template&id=8285de26&"
import script from "./QuillRichTextEditor.vue?vue&type=script&lang=js&"
export * from "./QuillRichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./QuillRichTextEditor.vue?vue&type=style&index=0&id=8285de26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports